<template lang="pug">
	div.encuesta
		div(v-if="datos.HasVotado")
			.tituloEncuesta.text-dark {{datos.Titulo}}
			chartjs-bar(
				:beginatzero="true"
				:title="{display: true, text: datos.Titulo}"
				:label="datos.Titulo"
				:legend="{display: false}"
				:height="100"
				:labels="labels"
				:data="data"
				:datalabel="datos.Titulo"
			)
		div.p-3(v-else)
			.tituloEncuesta.text-dark {{datos.Titulo}}
			table.table.table-hover
				tbody
					tr(
						v-for="(opcion, i) in datos.Opciones"
						:key="opcion.OpcionID"
					)
						td.text-left {{i + 1}} - {{opcion.Titulo}}
						td.text-right
							button.btn.btn-sm.btn-warning(@click="votar(opcion)") Votar
</template>

<script>
import axios from 'axios'
export default {
	props: ['id', 'datos', 'publicacionID'],
	data () {
		return {
			verResultados: false
		}
	},
	computed: {
		labels () {
			return this.datos.Opciones.map(val => {
				return val.Titulo
			})
		},
		data () {
			return this.datos.Opciones.map(val => {
				return val.Votos
			})
		}
	},
	methods: {
		votar (opcion) {
			const datos = {
				OpcionID: opcion.OpcionID
			}
			axios.post('muro/php/api/votarEncuesta.php', datos)
				.then(res => {
					this.$store.dispatch('muro/actualizarPublicacion', this.publicacionID)
				})
				.catch(e => {
					console.error(e.response.data.error)
				})
		}
	}
}
</script>


<style scoped>
.tituloEncuesta {
	position: relative;
	display: block;
	font-size: 1.3em;
	margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/contenidoEncuesta.vue